import { render } from "./Home.vue?vue&type=template&id=f38b710a&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=f38b710a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f38b710a"

export default script